import { AromaDatepickerRecipe } from "@zenchef/styled-system/recipes";
import DayView from "./DayView";
import MonthView from "./MonthView";
import YearView from "./YearView";
import { Translations } from "./types";
import { DatePicker as ArkUiDatePicker } from "@ark-ui/react";

interface Props {
  classes: ReturnType<AromaDatepickerRecipe>;
  defaultValue: ArkUiDatePicker.RootProps["defaultValue"];
  focusedValue?: ArkUiDatePicker.RootProps["focusedValue"];
  withDoubleArrows: boolean;
  translations: Translations;
}

export default function Views({
  classes,
  defaultValue,
  focusedValue,
  withDoubleArrows,
  translations,
}: Props) {
  return (
    <ArkUiDatePicker.Content className={classes.root}>
      <DayView
        classes={classes}
        defaultValue={defaultValue}
        focusedValue={focusedValue}
        withDoubleArrows={withDoubleArrows}
        translations={translations}
      />
      <MonthView
        classes={classes}
        translations={translations}
        defaultValue={defaultValue}
        focusedValue={focusedValue}
      />
      <YearView classes={classes} translations={translations} />
    </ArkUiDatePicker.Content>
  );
}
